export default "__VITE_ASSET__mTTEpliE__"